module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1187.13a52fe0.png";